class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/jwks`;
    }
    /**
     * Returns the signing key(s) in JWK Set format. Client use it to validate signatures of any JWT
     * (e.g. OpenID Connect ID Token) issued by the Authorization Server
     * (see [RFC-7517](https://www.rfc-editor.org/rfc/rfc7517.html#section-5))
     *
     * HTTP Method: get
     * Endpoint: /restapi/oauth/jwks
     * Rate Limit Group: NoThrottling
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
